<ng-container #spawn />
@if (ghostShellTempFixedConfig) {
    <data-viz-widget-auto-spawner [widgetConfig]="ghostShellTempFixedConfig" [dataSources]="dataSources" />
}
